/**
 * 16PF Personality Tests - English
 * Placeholder - Tests will be translated from Spanish in Sprint 5
 */

import { TestDefinition } from '../../types';

// Placeholder - will be populated with translated tests
export const TESTS_16_PERSONALITY: TestDefinition[] = [];
